var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoBespokeBenefits6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_10055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1566 41.4778L53.7289 38.4639L50.4756 52.209L64.3159 65.9541L67.5309 67.7395C68.3936 68.2185 69.3917 67.3723 69.0404 66.4599L59.6268 42.0166C59.5389 41.7883 59.3725 41.5977 59.1566 41.4778Z",
    fill: "#FFBE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2457 34.8633L41.4229 47.1385L52.5392 59.4137L64.3163 65.954L53.7294 38.4638L47.2457 34.8633Z",
    fill: "#DD9326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2453 34.8633L34.9997 41.6632L28.6475 55.3314L34.9997 68.9996C35.1817 68.9996 35.3607 68.9533 35.5193 68.8651L52.5388 59.4137L47.2453 34.8633Z",
    fill: "#FFAF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7539 34.8633L11.6406 47.1385L17.4604 59.4137L34.4799 68.8651C34.6384 68.9533 34.8174 68.9996 34.9995 68.9996V41.6632L22.7539 34.8633Z",
    fill: "#DD9326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7541 34.8633L17.4606 59.4137L2.46844 67.7393C1.60581 68.2184 0.607667 67.3721 0.959014 66.4598L10.3724 42.0166C10.4603 41.7883 10.6267 41.5976 10.8426 41.4777L22.7541 34.8633Z",
    fill: "#FFAF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0V52.1787C35.7544 52.1787 36.4147 51.7887 36.7898 51.2033C36.7923 51.2033 51.1309 28.7901 51.1309 28.7901C52.983 25.893 54.0566 22.4624 54.0566 18.7843C54.0566 8.41009 45.5246 0 35 0Z",
    fill: "#FC5E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3919 51.2033C36.3939 51.2033 47.5462 28.7901 47.5462 28.7901C48.9867 25.893 49.8217 22.4624 49.8217 18.7843C49.8217 8.41009 43.1858 0 34.9999 0C24.4752 0 15.9434 8.41009 15.9434 18.7843C15.9434 22.4624 17.0167 25.8932 18.8703 28.7901C18.8689 28.7901 33.2075 51.2033 33.2075 51.2033C33.5851 51.7887 34.2456 52.1787 34.9998 52.1787C35.5866 52.1787 36.1003 51.7887 36.3919 51.2033Z",
    fill: "#ED041D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 29.2201C40.8471 29.2201 45.5871 24.5479 45.5871 18.7844C45.5871 13.0209 40.8471 8.34863 35.0001 8.34863C29.153 8.34863 24.4131 13.0209 24.4131 18.7844C24.4131 24.5479 29.153 29.2201 35.0001 29.2201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 12.5225V25.0453C38.5082 25.0453 41.3522 22.242 41.3522 18.7839C41.3522 15.3258 38.5082 12.5225 35 12.5225Z",
    fill: "#ED041D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.117 18.7839C37.117 15.3258 36.169 12.5225 34.9997 12.5225C31.4914 12.5225 28.6475 15.3258 28.6475 18.7839C28.6475 22.242 31.4914 25.0453 34.9997 25.0453C36.169 25.0453 37.117 22.242 37.117 18.7839Z",
    fill: "#FF9A6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_10055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoBespokeBenefits6);
export default __webpack_public_path__ + "static/media/products_bruno_bespoke_benefits_6.815e2011d399e7ac431e07946883df90.svg";
export { ForwardRef as ReactComponent };